import React from 'react';
import { useSelector } from 'react-redux';

import SuperAdminDash from './superAdminDash';
import ItecDash from './itecDash';
// import ItecDashCrc from './itecDashCrc';
import AdminDash from './adminDash';
import CoreDash from './coreDash';
import UltimateDash from './uiltmateDash';
import UltimateCorpDash from './ultimateCorpDash';
// import useStyles from '../styles/index';

function Dashboard(props) {
    // const classes = useStyles();

    const userDetails = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails);

    const userTeam = userDetails.result && userDetails.result.data.features[0].team;
    const userType = userDetails.result && userDetails.result.data.features[0].roleText;
    //console.log(userTeam+"--"+userType);

    const loadDashBoard = () => {
        if (userTeam === 'ITeC Team' && userType === 'SuperAdmin') {
            return <SuperAdminDash />;
        }
        if (userTeam === 'ITeC Team' && userType !== 'SuperAdmin') {
            return <ItecDash />;
        }
        // if (userTeam === 'ITeC AM and above' && userType !== 'SuperAdmin') {
        //     return <ItecDashCrc />;
        // }
        if (userTeam === 'Team' && userType === 'Admin') {
            return <AdminDash />;
        }
        if (userTeam === 'Team' && userType !== 'Admin') {
            return <CoreDash />;
        }
        if (userTeam === 'Ultimate Client' && userType === 'Corporate Client') {
            return <UltimateCorpDash />;
        }
        if (userTeam === 'Ultimate Client' && userType === 'Individual Client') {
            return <UltimateDash />;
        }
        // else return(<div><h1>No Dashboard availble</h1></div>);
    };

    return <div>{loadDashBoard()}</div>;
}

export default Dashboard;
